import Loader from "react-loader-spinner";
import { Button, FormGroup, Row } from "react-bootstrap";
import { CheckLg, DashCircle, List, PlusSquareFill, PrinterFill } from "react-bootstrap-icons";
import { Fragment, useState, useRef, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import ModalProducts from "../../../Components/Modals/ModalProducts";
import { setDialog, setSelectProductGroupPop } from "../../store/api/Modals";
import ModalSelectProdcutGroup from "../ModalSelectProductGroup";
import { addPreCustomerProduct, deletePreCustomerProduct, getPreCustomerProductList, getPreCustomerProductList_Local } from "../../store/api/CustomerApi";
import { useHistory } from "react-router-dom";
import { convertPrecustomerProdutsToPreSale } from "../../../Sale/store/api/Invoice";
import ModalSearchStorage from "../../../Components/Modals/ModalSearchStorage";
import { invoiceTypes, keyIsLetterOrNumber } from "../../../store/api/CommonFunctions";
import ModalConvertToFormalInvoice from "../../../Sale/Components/ModalConvertToFormalInvoice";
import BihamtaTable from "../../../Components/BihamtaTable";

const PreCustomerProduct = (props) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const convertToFormal = useRef(false);
    const [showAddDiv, setShowAddDiv] = useState(false);
    const { preCustomerID, customerID, isPreCustomer } = props;
    const submitData = useRef({ UnitPrice: 0, Count: 1 });
    const [pending, setPending] = useState(false);
    const [submitError, setSubmitError] = useState({});
    const [showDivConvert, setDivConvert] = useState(false);
    const [selectedStorage, selectStorage] = useState({});
    const [selectedGroup, setGroupData] = useState({});
    const [selectedProduct, selectProduct] = useState({});
    const [totalPrice, setTotalPrice] = useState(0);
    const [unitPrice, setUnitPrice] = useState(0);
    const [popInvoice, setPopInvoice] = useState({ show: false });
    const [popStorage, setPopStorage] = useState({ show: false });
    const [popProduct, setPopProduct] = useState({ show: false });
    const settings = useSelector(state => state.SystemSettingsReducer.systemSettings);
    const productList = useSelector(state => state.customerDataReducer.preCustomerProductList.Data ?? []);
    const productGroupingType = settings?.find?.(s => s.SettingName === "ProductGrouppingType")?.SettingValue;
    const settingTaxPercent = Number(settings?.find?.(s => s.SettingName === "TaxPercent")?.SettingValue ?? 0);
    const tableColes = [
        { colTitle: "ردیف", colName: "RowNumber", showInMobile: true },
        { colTitle: " گروه کالا", colName: "ProductGroupName", showInMobile: true },
        { colTitle: "نام کالا", colName: "ProductName", showInMobile: true },
        { colTitle: "تعداد", colName: "Count", showInMobile: true },
        { colTitle: "قیمت واحد", colName: "UnitPrice", showInMobile: false, colType: "currency" },
        { colTitle: "قیمت کل", colName: "TotalPrice", showInMobile: false, colType: "currency" },
        { colTitle: "توضیحات", colName: "Description", showInMobile: false, colType: "string", maxTextLength: 150 }
    ]
    const tableRowButtons = [{
        title: "حذف ردیف", type: "delete", className: "group-Btn-smalll btn-primary",
        onclick: (item) => dispatch(setDialog({
            status: 'show',
            arrayBtn: ['yes', 'no'],
            dialogTitle: 'حذف ردیف',
            dialogText: 'آیا از حذف مطمئن هستید؟',
            okOperation: deleteRow(item.ID)
        }))
    }];
    const showGroupModal = (e) => {
        if (e.key) {
            if (!keyIsLetterOrNumber(e.keyCode, e.key)) {
                return;
            }
            e.preventDefault();
        }
        const onSelectG = (group) => {
            if (!group || group.length === 0) {
                return;
            }
            setGroupData(group);
        }
        dispatch(setSelectProductGroupPop({ show: true, onSelect: onSelectG, value: e.key }));
        const inputName = document.getElementById("preCustProductName");
        inputName.focus();
    }
    function showModalProduct(e) {
        if (e.key) {
            if (!keyIsLetterOrNumber(e.keyCode, e.key)) {
                return;
            }
            e.preventDefault();
        }
        const setData = (data) => {
            if (data) {
                submitData.current.ProductID = data.ProductID;
                selectProduct(data);
            }
        }
        setPopProduct({ show: true, value: e.key, setProductData: setData });
        const inputCount = document.getElementById("preCustProductCount");
        inputCount.focus();
        if (e.key && e.key === "Enter") {
            add(e);
        }
    }
    function prepareToAdd() {
        setShowAddDiv(true);
    }
    function hideAddDiv() {
        setShowAddDiv(false);
    }
    const add = (e) => {
        if (pending) {
            return;
        }
        if (e.key && e.key !== "Enter") {
            return;
        }
        const err = {};
        if (!selectedProduct.ProductID) {
            err.ProductID = "انتخاب کالا الزامی است";
        }
        if (!selectedGroup.GroupID) {
            err.GroupID = "انتخاب گروه کالا الزامی است";
        }
        if (!submitData.current.Count || submitData.current.Count === '') {
            submitData.current.Count = 1;
        }
        if (!submitData.current.UnitPrice || submitData.current.UnitPrice === '') {
            submitData.current.UnitPrice = 0;
        }
        setSubmitError(err);
        if (Object.keys(err).length > 0) {
            return;
        }
        submitData.current.ProductGroupID = selectedGroup.GroupID;
        submitData.current.ProductID = selectedProduct.ProductID;
        submitData.current.CustomerID = preCustomerID;
        submitData.current.IsPreCustomer = isPreCustomer;
        const onSuccess = (item) => {
            item.ProductName = selectedProduct.ProductName;
            item.ProductModel = selectedProduct.ProductModel;
            item.ProductGroupName = selectedGroup.GroupName;
            item.TotalPrice = totalPrice;
            hideAddDiv();
            selectProduct({});
            setGroupData({});
            setUnitPrice(0);
            setTotalPrice(0);
            submitData.current = { UnitPrice: 0, Count: 1 };
            dispatch(getPreCustomerProductList_Local({ Data: [...productList, item] }));
            setPending(false);
        }
        setPending(true);
        dispatch(addPreCustomerProduct(submitData.current, onSuccess));
    }
    const deleteRow = (id) => {
        return () => {
            const onSuccess = () => {
                const removed = productList.filter(p => p.ID !== id);
                dispatch(getPreCustomerProductList_Local({ Data: removed }));
            }
            dispatch(deletePreCustomerProduct(id, onSuccess));
        }
    }
    const onChange = (value, isUnitPrice) => {
        if (isUnitPrice) {
            value = value.replace(/,/g, "");
            submitData.current.UnitPrice = Number(value);
            if (value === '') {
                setUnitPrice(0);
            }
            else {
                setUnitPrice(Number(value).toLocaleString(navigator.language, { minimumFractionDigits: 0 }));
            }
            if (value === '' || !submitData.current.Count || submitData.current.Count === '') {
                return;
            }
            setTotalPrice((Number(submitData.current.Count) * Number(value)).toLocaleString(navigator.language, { minimumFractionDigits: 0 }));
        }
        else {
            submitData.current.Count = Number(value);
            if (value === '' || !submitData.current.UnitPrice || submitData.current.UnitPrice === '') {
                return;
            }
            setTotalPrice((Number(submitData.current.UnitPrice) * Number(value)).toLocaleString(navigator.language, { minimumFractionDigits: 0 }));
        }
    }
    function printProducts(e) {
        history.push({
            pathname: "/PrintViewer/PreCustomerProducts/" + e.ctrlKey,
            state: {
                dataUrl: `api/CustomersAPI/GetPreCustomerProductList?customerID=${preCustomerID}&isPreCustomer=${isPreCustomer}`,
                method: "get"
            }
        });
    }
    function showModalStorage(e) {
        if (e.key) {
            if (!keyIsLetterOrNumber(e.keyCode)) {
                return;
            }
            e.preventDefault();
        }
        const onSelectStorage = (data) => {
            if (data) {
                selectStorage(data);
            }
        }
        setPopStorage({ show: true, setStorageData: onSelectStorage, value: e.key })
    }
    function convertToPreSale() {
        const onSuccess = (invoiceID) => {
            setDivConvert(false);
            //history.push(`/Sale/Invoice/PreSale/${invoiceID}/${convertToFormal.current}`);
        }
        dispatch(convertPrecustomerProdutsToPreSale(preCustomerID, customerID, selectedStorage?.StorageID, onSuccess));
    }
    function prepareForConvert() {
        if (convertToFormal.current) {
            const details = [...productList];
            details.forEach(l => {
                l.ProductCount = l.Count;
                l.TaxPercent = settingTaxPercent;
                l.Discount = l.DiscountPercent = 0;
                l.Tax = l.TotalPrice * l.TaxPercent / 100;
                l.PureTotalPrice = l.TotalPrice + l.Tax;
            });
            setPopInvoice({ show: true, invoiceDetails: details, customerID: customerID, invoiceType: invoiceTypes.PreSale });
        }
        else {
            setDivConvert(true);
        }
    }
    function cancelInvoice() {
        if (convertToFormal.current) {
            setPopInvoice({ show: false });
        }
        else {
            setDivConvert(false);
        }
    }
    const selectText = useCallback((e) => {
        e.target.select();
    })
    useEffect(() => {
    }, [])
    return (
        <Fragment>
            {Array.isArray(productList) && popInvoice.show && <ModalConvertToFormalInvoice popData={popInvoice} setPopData={setPopInvoice} />}
            {popStorage.show && <ModalSearchStorage popData={popStorage} setStoragePoup={setPopStorage} />}
            <ModalSelectProdcutGroup selectOne={true} />
            {popProduct.show && <ModalProducts popData={popProduct} setProductPopup={setPopProduct} productGrouppingType={productGroupingType} />}
            {showAddDiv &&
                <form>
                    <Row className="rowBorder">
                        <FormGroup className="col-md-2">
                            <label style={{ display: "block " }}>گروه کالا</label>
                            <input type="text" className="form-control" value={selectedGroup.GroupName ?? ""} readOnly onKeyDown={showGroupModal} />
                            <Button className="btn-input-tiny" onClick={showGroupModal} style={{top:25, left:14}}><List size={22} /></Button>
                            {submitError.GroupID && <small className="errors">{submitError.GroupID}</small>}
                        </FormGroup>
                        <FormGroup className="col-md-2">
                            <label style={{ display: "block " }}>نام کالا</label>
                            <input type="text" id="preCustProductName" className="form-control" onKeyDown={showModalProduct}
                                value={selectedProduct.ProductName ? (selectedProduct.ProductName + "-" + selectedProduct.ProductModel) : ""} readOnly />
                            <Button className="btn-input-tiny" onClick={showModalProduct}  style={{top:25, left:15}}><List size={22} /></Button>
                            {submitError.ProductID && <small className="errors">{submitError.ProductID}</small>}
                        </FormGroup>
                        <FormGroup className="col-md-2">
                            <label>تعداد کالا</label>
                            <input id="preCustProductCount" type="number" className="form-control" defaultValue={1} onChange={e => onChange(e.target.value, false)} onKeyDown={add} onFocus={selectText} />
                        </FormGroup>
                        <FormGroup className="col-md-2">
                            <label>قیمت واحد</label>
                            <input type="text" className="form-control" onChange={e => onChange(e.target.value, true)} value={unitPrice} onKeyDown={add} onFocus={selectText} />
                        </FormGroup>
                        <FormGroup className="col-md-2">
                            <label>قیمت کل</label>
                            <input type="text" className="form-control" value={totalPrice} readOnly onKeyDown={add} />
                        </FormGroup>
                        <FormGroup className="col-md-2">
                            <label>توضیحات</label>
                            <input type="text" className="form-control" onChange={e => submitData.current.Description = e.target.value} onKeyDown={add} onFocus={selectText} />
                        </FormGroup>
                        <div>
                            <Button variant="info" className="group-Btn mt-2" onClick={add}>
                                {pending && <Fragment> <Loader width={15} height={15} style={{ display: "inline-block" }} type="BallTriangle" color="white" />&nbsp; صبر کنید</Fragment>}
                                {!pending && <Fragment><CheckLg />&nbsp;ثبت محصول</Fragment>}
                            </Button>
                            <Button variant="danger" className="group-Btn mt-2" onClick={hideAddDiv}>
                                <DashCircle size={16} />&nbsp;انصراف
                            </Button>
                        </div>
                    </Row>
                </form>
            }
            {!showAddDiv &&
                <div className="mt-1">
                    <PlusSquareFill size={25} className="hoverIcon" color="#820b8fe3" style={{ boxShadow: "1px 1px 2px", borderRadius: "3px", cursor: "pointer" }} onClick={prepareToAdd} />
                    <PrinterFill size={25} className="hoverIcon" color="#156a98" style={{ float: "left", cursor: "pointer" }} onClick={e => printProducts(e)} />
                </div>
            }
            <BihamtaTable columns={tableColes} rowButtons={tableRowButtons} reducerName="customerDataReducer" objectName="preCustomerProductList" />
            {showDivConvert &&
                <div className="row">
                    <div className="col-md-2 form-group">
                        <label>انبار مبدا</label>
                        <input type="text" className="form-control" readOnly value={selectedStorage.StorageName ?? ""} onKeyDown={showModalStorage} />
                        <Button className="btn-input-tiny" onClick={showModalStorage}  style={{top:27, left:14}}><List size={21} /></Button>
                    </div>
                    <div className="mt-1">
                        <Button className="group-Btn" onClick={convertToPreSale}>ثبت پیش فاکتور</Button>
                        <Button className="group-Btn" variant="danger" onClick={cancelInvoice}><DashCircle size={16} />&nbsp;انصراف</Button>
                    </div>
                </div>
            }
            {!showDivConvert &&
                <Fragment>
                    <div>
                        <input type="checkbox" className="form-check-input" onChange={e => convertToFormal.current = e.target.checked} style={{ borderColor: "rgb(213 93 0)", borderWidth: "2px" }} />
                        &nbsp;
                        <label style={{ marginTop: "3px", color: "#ff2d00" }}>فاکتور رسمی</label>
                    </div>
                    <Button className="group-Btn" disabled={!customerID} onClick={prepareForConvert}>ثبت پیش فاکتور فروش</Button>
                </Fragment>
            }
        </Fragment>
    )
}
export default PreCustomerProduct;